export const fontLetterSpacingTokens = () => {
  return 'unset';
};
export const fontLetterSpacingTokensNova = () => {
  return 'normal';
};
//# sourceMappingURL=fontLetterSpacing.js.map